import { WordingMultiFitnessYogaPilates } from '@/types';

export const MULTI_FITNESS_YOGA_PILATES_WORDING_SE: WordingMultiFitnessYogaPilates = {
  components_header_media_content: 'Kondition',
  components_header_media_1: 'För män',
  components_header_media_2: 'För kvinnor',
  components_header_media_multi_content_2: 'Yoga',
  components_header_media_multi_content_3: 'Pilates',
  hero_text: 'Träna smartare, må bättre.',
  hero_button_text: 'Kom igång nu',
  components_ressources_subheader_text: 'Guider och tips',
  components_ressources_span_text: 'Den kombinerar yogans jordnära fokus, pilates kontrollerade precision och styrketräningens dynamiska utmaning för att stödja en välbalanserad och hälsosam livsstil.',
  components_ressources_card_1_title: 'Yogatips',
  components_ressources_card_1_text: 'Snabbguide för bättre balans, andning och flöde.',
  components_ressources_card_2_title: 'Pilates-tips',
  components_ressources_card_2_text: 'Enkla tips för att stärka dina coremuskler och förbättra kontrollen.',
  components_notes_and_google_title_1: 'Bygg styrka',
  components_notes_and_google_title_2: 'Yoga lugn',
  components_notes_and_google_title_3: 'Pilates-core',
  media_content_section_multi_1_subheader_text: 'Träningsvideor',
  media_content_section_multi_2_subheader_text: 'Yogavideor',
  media_content_section_multi_3_subheader_text: 'Pilatesvideor',
  text_media_1: 'Män',
  text_media_2: 'Kvinnor',
  page_media_content_menu_biceps: 'Biceps',
  page_media_content_menu_triceps: 'Triceps',
  page_media_content_menu_back: 'Tillbaka',
  page_media_content_menu_chest: 'Bröst',
  page_media_content_menu_legs: 'Ben',
  page_media_content_menu_shoulders: 'Axlar',
  page_media_content_menu_abdominals: 'Magmuskler',
  components_text1_subheader_text: 'Hälsosam kost för ditt aktiva liv',
  components_text1_span_text: 'Hälsosamma recept som stödjer din träning och förbättrar ditt välbefinnande.',
  components_footer_text: 'Stärk din kropp, balansera ditt sinne och rör dig med mening – din plats för gym, yoga och pilates.',
};